/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Restore_PurchaseInputs */

const en_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore Purchases`)
};

const ar_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استعادة المشتريات`)
};

const de_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufe wiederherstellen`)
};

const es_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar compras`)
};

const fr_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération des achats`)
};

const it_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristina gli acquisti`)
};

const ja_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入の復元`)
};

const ko_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 복원`)
};

const pt_br_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar compras`)
};

const ru_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановить покупки`)
};

const th_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กู้คืนการซื้อ`)
};

const tr_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın Alımları Geri Yükle`)
};

const zh_cn_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复购买`)
};

const zh_tw_restore_purchase = /** @type {(inputs: Restore_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`還原購買`)
};

/**
* | output |
* | --- |
* | "Restore Purchases" |
*
* @param {Restore_PurchaseInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const restore_purchase = /** @type {((inputs?: Restore_PurchaseInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Restore_PurchaseInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_restore_purchase(inputs)
	if (locale === "ar") return ar_restore_purchase(inputs)
	if (locale === "de") return de_restore_purchase(inputs)
	if (locale === "es") return es_restore_purchase(inputs)
	if (locale === "fr") return fr_restore_purchase(inputs)
	if (locale === "it") return it_restore_purchase(inputs)
	if (locale === "ja") return ja_restore_purchase(inputs)
	if (locale === "ko") return ko_restore_purchase(inputs)
	if (locale === "pt_br") return pt_br_restore_purchase(inputs)
	if (locale === "ru") return ru_restore_purchase(inputs)
	if (locale === "th") return th_restore_purchase(inputs)
	if (locale === "tr") return tr_restore_purchase(inputs)
	if (locale === "zh_cn") return zh_cn_restore_purchase(inputs)
	return zh_tw_restore_purchase(inputs)
});